import { h, Fragment } from "preact";
import { Alert, Box, Stack, Typography, Tooltip } from "@mui/material";

import ProxiedCard from "../Common/ProxiedCard";
import palette from "../../theme/palette";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
//import TaskIcon from '@mui/icons-material/Task';
import GroupIcon from '@mui/icons-material/Group';

export default function SellerCard({ row, mode, rw }) {

    return (
        <Stack spacing={0.5}>
            <Box display="flex" alignItems="center" justifyContent="space-between" >
                <Box >
                    <Typography variant="h5">{row.name}{row.ip && (
                        <Tooltip title={`${row.name} est le vendeur référent`}>
                            <span style="margin-left: 10px;">★</span>
                        </Tooltip>
                    )}
                    </Typography>
                    {row.up_u && <Stack>
                        <Typography variant="body1">{row.marital}</Typography>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div>
                                {row.age !== undefined && <Typography variant="body1">{row.birth} ({row.age} ans)</Typography>}
                                {row.age === undefined && <Typography variant="body1"><em>Age indéterminé</em></Typography>}
                            </div>
                            {row.union_with && <div style={{ marginLeft: "20px", padding: "5px", color: "gray", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <GroupIcon style={{ width: "16px", marginRight: "10px" }} />
                                <Typography variant="body2">{row.union_with}</Typography>
                            </div>}
                        </div>
                        {(mode === "VN" || mode === "AM") && <Typography variant="body2">{row.ml}</Typography>}
                        {(mode === "VN" || mode === "AM") && <Typography variant="body2">{row.tel1} </Typography>}
                    </Stack>}
                </Box>
                {mode !== "NT" && row.up_u && <Box display="flex" alignItems="center" justifyContent="flex-end" >
                    <Box >
                        <Tooltip title={row.hadcfsm ? "Profil utilisateur complet" : "Profil utilisateur incomplet"}>
                            <AccountCircleIcon
                                style={{
                                    color: row.hadcfsm ? palette.success.main : palette.warning.main,
                                }}
                            />
                        </Tooltip>
                    </Box>
                    {row.own && <Box >
                        <Tooltip title={row.hsm ? "Mandat signé" : "Mandat en attente de signature"}>
                            <FingerprintIcon
                                style={{
                                    color: row.hsm ? palette.success.main : palette.warning.main,
                                }}
                            />
                        </Tooltip>
                    </Box>}
                    {row.own && <Box >
                        <Tooltip title={row.hso ? "Offre signée" : "Offre en attente de signature"}>
                            <FingerprintIcon
                                style={{
                                    color: row.hso ? palette.success.main : palette.warning.main,
                                }}
                            />
                        </Tooltip>
                        {/* <Tooltip title={row.offer_docs ? "Documents complets" : "Documents incomplets"}>
                                    <TaskIcon
                                        style={{
                                            color: row.offer_docs ? palette.success.main : palette.warning.main,
                                        }}
                                    />
                                </Tooltip> */}
                    </Box>}
                </Box>}

                {
                    !row.up_u && <Box display="flex" alignItems="center" justifyContent="flex-end" >
                        <Box >
                            <Alert severity="warning">Pas encore inscrit</Alert>
                        </Box>
                    </Box>
                }
                {mode === "NT" && <Box display="flex" alignItems="center" justifyContent="flex-end" >
                    <Tooltip title={row.offer_docs ? "Profil utilisateur complet" : "Profil utilisateur incomplet"}>
                        <AccountCircleIcon
                            style={{
                                color: row.offer_docs ? palette.success.main : palette.warning.main,
                            }}
                        />
                    </Tooltip>
                </Box>}
            </Box >
            <ProxiedCard proxied={row.proxied} mode={mode} target="VN" />
        </Stack >
    );
}
